import { useDemoRequest } from "@/components/feature/DemoRequest";

export default function PricingHero() {
  const { open } = useDemoRequest();

  return (
    <section className="relative pt-24 pb-16 md:pt-32 md:pb-20 bg-graphite-900 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-graphite-850 via-graphite-900 to-graphite-950" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-emerald-accent/8 via-transparent to-transparent" />
      
      {/* Subtle grid pattern */}
      <div className="absolute inset-0 grid-pattern opacity-30" />

      <div className="relative z-10 section-padding">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-graphite-700 bg-graphite-800/60 mb-6">
            <span className="w-2 h-2 rounded-full bg-emerald-accent" />
            <span className="text-xs font-medium text-silver-300 tracking-wide">
              Flexible Plans
            </span>
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight mb-6">
            Flexible Pricing for Every{" "}
            <span className="text-emerald-accent">Stage of Growth</span>
          </h1>

          <p className="text-base sm:text-lg text-silver-300 max-w-2xl mx-auto leading-relaxed mb-10">
            Choose a plan that fits your business needs. StackMap pricing is tailored based on your 
            company size, selected modules, implementation scope, and support requirements.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={open}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-emerald-accent text-graphite-900 text-sm font-semibold hover:bg-emerald-hover transition-colors cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-file-list-3-line text-base" />
              </span>
              Request Pricing
            </button>
            <button
              onClick={open}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-graphite-600 text-silver-200 text-sm font-medium hover:text-white hover:border-silver-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-calendar-check-line text-base" />
              </span>
              Book a Demo
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}